<paid-summary-detail-description>

    <style>
        .amount{
            font-weight: bold;
            font-size: 1.5rem;
        }
        .tax_withholding{
            color:red
        }
    </style>

    <div class="container_heading">
        <h2 class="heading-02" style="padding-left: 0">
            受注プロジェクトの合算情報
        </h2>
    </div>
    <table class="contents_table pay-detail_table margin-spacing-3_top">
        <tbody>
        <tr>
            <th>対象年</th>
            <th>クライアントID</th>
            <th>クライアント名</th>
            <th>会社種類</th>
            <th>プロジェクト件数</th>
            <th>受注金額合計（税抜）</th>
            <th>消費税額合計</th>
            <th>源泉額合計</th>
            <th>受取額合計（税込）</th>

            <th>受取済の<br>報酬総額</th>
            <th>CROCO預り中の<br>報酬残額</th>
        </tr>

        <tr>
            <td>{props.description.target_year}年</td>
            <td>{props.description.client_id}</td>
            <td>{props.description.client_name}</td>
            <td>
                <span if={props.description.company_type==1}>個人</span>
                <span if={props.description.company_type==2}>法人</span>
            </td>
            <td><number-format number={props.description.project_count}></number-format>件</td>
            <td><number-format number={props.description.sub_amount}></number-format>円</td>
            <td><number-format number={props.description.tax}></number-format>円</td>
            <td>
                <span if={props.description.company_type==1}>
                    ---
                </span>
                <span if={props.description.company_type==2} class="tax_withholding">
                    <number-format number={props.description.tax_withholding}></number-format>円
                </span>
            </td>
            <td class="amount"><number-format number={props.description.amount}></number-format>円</td>

            <td><number-format number={props.description.paid_reward_price}></number-format>円</td>
            <td><number-format number={props.description.not_paid_reward_price}></number-format>円</td>
        </tr>

        </tbody>
    </table>

    <script>
        import di from "dependency-injection";

        export default {
            state: {

            },
            onBeforeMount(props,state){
            },
            onMounted(props,state){
            }
        }
    </script>
</paid-summary-detail-description>